import { withDevtools } from '@angular-architects/ngrx-toolkit';
import { computed, inject } from '@angular/core';
import { signalStore, withComputed } from '@ngrx/signals';
import { Company, PagedResponse, QueryFiltersParams, QueryPagingParams } from 'mbs-ui-shared@models';
import { CompaniesService } from 'mbs-ui-shared@services/companies.service';
import { withPagingAndData } from 'mbs-ui-shared@store/withPagingAndDataStoreFeature/withPagingAndData';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export const CompaniesStore = signalStore(
  { providedIn: 'root' },
  withDevtools('CompaniesStore'),
  withPagingAndData<Company>({
    selectId: (entity) => entity.id,
    getEntityById: () => {
      const service = inject(CompaniesService);
      return (id: string): Observable<Company> => service.getById(id);
    },
    getEntitiesByIds: () => {
      const service = inject(CompaniesService);
      return (ids: string[]): Observable<Company[]> => service.get({ ids }).pipe(map((r) => r.data));
    },
    getEntities: () => {
      const service = inject(CompaniesService);
      return (params: QueryFiltersParams & QueryPagingParams): Observable<PagedResponse<Company>> => service.get(params);
    }
  }),
  // Custom selector: default company
  withComputed((store) => ({
    selectDefaultCompany: computed(() => store.entities().find((c) => c.defaultCompany))
  }))
);

export type CompaniesStore = InstanceType<typeof CompaniesStore>;
